export default "__VITE_ASSET__DbZUzX9Q__"